// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scan-progress-bar {
  font-size: 18px !important;
  font-weight: 700;
  height: 30px !important;
}

.button-scan{
  color: white !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  border: 2px solid white !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Devices/DeviceScanControl.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;AACpC","sourcesContent":[".scan-progress-bar {\n  font-size: 18px !important;\n  font-weight: 700;\n  height: 30px !important;\n}\n\n.button-scan{\n  color: white !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border: 2px solid white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
